import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { UiKit } from 'components';
import { ReactComponent as AddIcon } from 'assets/img/icons/add.svg';

export default function ZeroState({
  error = '',
  title = '',
  helptext = '',
  buttonText = '',
  onButtonClick = () => {}
}) {
  return (
    <div className={styles.zeroState}>
      <div className={cn(styles.card, { [styles.danger]: !!error })}>
        <div className={styles.content}>
          <div className={styles.iconWrapper}>
            <AddIcon className={styles.icon} />
          </div>
          <div className={styles.column}>
            <p>{title}</p>
            <span>{helptext}</span>
          </div>
        </div>
        <UiKit.Button
          variant="outline"
          onClick={onButtonClick}
          className={styles.button}
        >
          <AddIcon />
          {buttonText}
        </UiKit.Button>
      </div>
      <UiKit.Error msg={error} />
    </div>
  );
}
